import { Component, ElementRef, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MandateListComponent } from './mandate-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { HttpClient } from "@angular/common/http";
import { MandateService } from './mandate.service';

const LIST_ENDPOINT = '/mandates';

@Component({
    selector: 'convfact-mandatedelete',
    templateUrl: './mandate-dialog-delete.component.html',
    styleUrls: ['./mandate.component.css'],
    providers: [MandateService],
    standalone: false
})
export class MandateDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error: boolean = false;

    constructor(public dialogRef: MatDialogRef<MandateListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient, public snackBar: MatSnackBar,
        public mandateService: MandateService) { }

    delete() {
        this.mandateService.deleteData(this.uid);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }

}